<template>
  <div class="block-item-container">
    <div
      class="block-item-title-content flex justify-between items-center"
      style="margin-bottom: 20px"
    >
      <div class="title">您对这次导师辅导满意吗？</div>
    </div>
    <div v-if="process && !process.rate" class="feedback-list-container flex items-center">
      <div class="feedback-item" @click="submitRate('满意')">
        <i class="iconfont iconmanyi"></i>
        <span>满意</span>
      </div>
      <div class="feedback-item" @click="submitRate('一般')">
        <i class="iconfont iconmeh"></i>
        <span>一般</span>
      </div>
      <div class="feedback-item" @click="submitRate('不满意')">
        <i class="iconfont iconfont iconbumanyi"></i>
        <span>不满意</span>
      </div>
    </div>
    <div v-else class="feedback-result">
      感谢您的反馈！详细的建议可在问卷中填写或直接找客服反馈。
    </div>
    <div class="flex items-center">
      <CompleteBtn
        class="feedback-btn"
        text="填问卷"
        style="margin-right: 12px"
        @clickBtn="handleFeedback"
      />
      <CompleteBtn
        class="feedback-btn"
        text="找客服"
        type="cancel"
        @clickBtn="showUdesk"
      />
    </div>
  </div>
</template>
<script>
import api from "@/api";
import { dealSignatrue, routerTo } from "@/assets/js/util";
import CompleteBtn from "../CompleteButton/CompleteButton.vue";

export default {
  name: "Feedback",
  components: {
    CompleteBtn,
  },
  props: {
    process: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleFeedback() {
      routerTo("https://wj.qq.com/s2/3590730/a259/", "_blank");
    },
    showUdesk() {
      const udesk_container = document.querySelector("#udesk_btn a");
      if (udesk_container) {
        udesk_container.click();
      }
    },
    async submitRate(rate) {
      let params = {
        cv_token: this.$store.state.editor.cvDetail.basic_info.token,
        rate,
      };
      params = await dealSignatrue(params);
      const res = await api.cvsEditor.mentorUpdateRate(params);
      if (res.code === 1000) {
        this.$message.success("提交成功");
        this.$emit("refresh");
      } else {
        this.$message.error("提交失败");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.feedback-list-container {
  margin-bottom: 20px;
  .feedback-item {
    display: flex;
    align-items: center;
    color: #5a616e;
    cursor: pointer;
    .iconfont {
      font-size: 16px;
      margin-right: 4px;
    }
    &:not(:last-child) {
      margin-right: 32px;
    }
  }
}
.feedback-result {
  color: $text-color;
  font-size: 14px;
  margin-bottom: 20px;
}
.feedback-btn {
  width: 80px;
  height: 28px;
  border-radius: 18px;
  white-space: nowrap;
}
</style>
